var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 14.8C7.3001 14.8 6.6001 14.4 6.2001 13.8C6.0001 13.4 6.1001 13 6.5001 12.8C6.9001 12.6 7.3001 12.7 7.5001 13.1C7.7001 13.5 8.3001 13.5 8.5001 13.1C8.7001 12.7 9.2001 12.6 9.5001 12.8C9.9001 13 10.0001 13.5 9.8001 13.8C9.4001 14.4 8.7001 14.8 8.0001 14.8Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 12.1H3.00013C2.60013 12.1 2.20013 11.9 2.00013 11.5C1.80013 11.1 1.90013 10.7 2.10013 10.4C3.10013 9.10005 3.60013 7.60005 3.60013 6.00005V5.70005C3.60013 3.30005 5.60013 1.30005 8.00013 1.30005C10.4001 1.30005 12.4001 3.30005 12.4001 5.70005V6.00005C12.4001 7.60005 12.9001 9.10005 13.9001 10.4C14.1001 10.7 14.2001 11.2 14.0001 11.5C13.8001 11.9 13.4001 12.1 13.0001 12.1ZM3.80013 10.6H12.2001C11.4001 9.20005 10.9001 7.60005 10.9001 6.00005V5.70005C10.9001 4.10005 9.60013 2.80005 8.00013 2.80005C6.40013 2.80005 5.10013 4.10005 5.10013 5.70005V6.00005C5.10013 7.60005 4.60013 9.20005 3.80013 10.6Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.dfada1abc3ce470d8860380a9ddd8bdd.svg";
export { ForwardRef as ReactComponent };